module.exports = __webpack_public_path__ + "static/img/UrgencyPlaying.4a97497e.png";